import { DateToMillisec } from "../../../common/helpers/utils";

export const getAlerts = data => {
  let alerts = [];
  if (data && data.length) {
    data.map(dataArr => {
      dataArr.values.filter(item => {
        if (item.alertTriggered) alerts.push(item);
      });
    });
    return alerts;
  }
};

export const getAlarms = data => {
  let alarms = [];
  if (data && data.length) {
    data.map(dataArr => {
      dataArr.values.filter(item => {
        if (item.alarmTriggered) alarms.push(item);
      });
    });
    return alarms;
  }
};

export const notificationSeries = (list, type) => {
  let listObj = [];
  list.sort((a, b) => {
    return a.capturedTime - b.capturedTime;
  });
  if (type === "alert") {
    list = list.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          selfItem =>
            selfItem.alarms[0].triggeredDate === item.alarms[0].triggeredDate &&
            selfItem.alarms[0].adminDesc === item.alarms[0].adminDesc
        )
    );
  }
  list.map((item, index) => {
    let listItem = {};
    listItem.x = item.alarms[0].triggeredDate;
    listItem.title = "   ";
    listItem.width = 16;
    listItem.height = 16;
    listItem.color = "red";
    listItem.shape =
      type=== "alarm"
        ? "url(https://connect.fluke.com/alarm_red.png)"
        : "url(https://connect.fluke.com/alert_red.png)";
    listItem.id = index;
    listItem.unit = type === "alarm" ? item.alarms[0].unit : item.value;
    listItem.triggeredValue =
      type === "alarm"
        ? Number(item.value).toFixed(item.alarms[0].decimalPlaces) +
          " " +
          item.alarms[0].unit
        : item.value;
    listItem.description =
      type === "alarm" ? item.alarms[0].dataType : item.alarms[0].adminDesc;
    listItem.capturedTime = DateToMillisec(item.alarms[0].triggeredDate);
    listItem.states = {
      hover: {
        fillColor: "black"
      }
    };
    listObj.push(listItem);
  });
  return listObj;
};
